import { render } from "./AntdvTestView.vue?vue&type=template&id=80467750&ts=true"
import script from "./AntdvTestView.vue?vue&type=script&lang=ts"
export * from "./AntdvTestView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__